/**
 * SDK 错误类型
 *
 * 带状态码,供调用方区分 401(未登录)等场景。
 * 阶段2 由请求层在 401/网络异常/非 2xx 时抛出。
 */
export class SdkError extends Error {
  constructor(
    public code: number,
    message: string
  ) {
    super(message);
    this.name = 'SdkError';
  }
}
